module.exports = __webpack_public_path__ + "126e7639aea5720f000880845a1456be.png";